<template>
    <div>
        <div class="page-title">主体信息</div>
        
        <pay-box title="营业执照" sub-title="请上传营业执照，需年检章齐全，当年注册除外" v-if="!applyManager.isPerson()">
            
            <div class="pay-apply-item has-tips">
                
                <div class="pay-apply-item-title">营业执照扫描件</div>
                
                <div class="pay-apply-item-content">
                    <div class="thumb-img">
                        
                        <upload-image
                            v-model="params.business_license_info.img_url"
                            :done="busLicUploadDone"
                            :action="uploadBusLicUrl"
                            class="pay-apply-upload"
                        />
                    
                    </div>
                    
                    <div class="pay-apply-tips">
                        （1）请上传证件的彩色扫描件或彩色数码拍摄件，黑白复印件需加盖公章（公章信息需完整） 。 <br>
                        （2）不得添加无关水印（非微信支付商户申请用途的其他水印）。<br>
                        （3）需提供证件的正面拍摄件，完整、照面信息清晰可见。信息不清晰、扭曲、压缩变形、反光、不完整均不接受。<br>
                        （4）不接受二次剪裁、翻拍、PS的证件照片。<br>
                    </div>
                
                </div>
            
            
            </div>
            
            
            <div class="pay-apply-item">
                
                <div class="pay-apply-item-title">营业执照注册号</div>
                
                <div class="pay-apply-item-content">
                    <at-input v-model="params.business_license_info.business_license_number" class="pay-apply-input"/>
                </div>
            
            </div>
            
            <div class="pay-apply-item">
                
                <div class="pay-apply-item-title">商户名称</div>
                
                <div class="pay-apply-item-content">
                    <at-input v-model="params.business_license_info.merchant_name" class="pay-apply-input"/>
                </div>
            
            </div>
            
            <div class="pay-apply-item">
                
                <div class="pay-apply-item-title">经营者姓名</div>
                
                <div class="pay-apply-item-content">
                    <at-input v-model="params.business_license_info.legal_person" class="pay-apply-input"/>
                </div>
            
            </div>
        
        
        </pay-box>
        
        
        <pay-box title="法人证件" sub-title="请上传法人的证件信息">
            
            <div class="pay-apply-item has-tips">
                
                <div class="pay-apply-item-title">身份证人像面照片</div>
                
                <div class="pay-apply-item-content">
                    <div class="thumb-img">
                        
                        <upload-image
                            v-model="params.id_card_info.img_a_url"
                            :action="uploadIdCardAUrl"
                            :done="idCardADone"
                            class="pay-apply-upload"
                        />
                    
                    </div>
                </div>
            </div>
            
            <div class="pay-apply-item has-tips">
                
                <div class="pay-apply-item-title">身份证国徽面照片</div>
                
                <div class="pay-apply-item-content">
                    <div class="thumb-img">
                        
                        <upload-image
                            v-model="params.id_card_info.img_b_url"
                            :action="uploadIdCardBUrl"
                            :done="idCardBDone"
                            class="pay-apply-upload"
                        />
                    
                    </div>
                </div>
            </div>
            
            <div class="pay-apply-tips">请上传彩色照片 or 彩色扫描件 or
                加盖公章鲜章的复印件，可添加“微信支付”相关水印（如微信支付认证）
            </div>
            
            
            <div class="pay-apply-item">
                
                <div class="pay-apply-item-title">身份证姓名</div>
                
                <div class="pay-apply-item-content">
                    <at-input v-model="params.id_card_info.id_card_name" class="pay-apply-input"/>
                </div>
            
            </div>
            
            <div class="pay-apply-item">
                
                <div class="pay-apply-item-title">身份证件号码</div>
                
                <div class="pay-apply-item-content">
                    <at-input v-model="params.id_card_info.id_card_number" class="pay-apply-input"/>
                </div>
            
            </div>
            
            <div class="pay-apply-item">
                
                <div class="pay-apply-item-title">证件有效期类型</div>
                
                <div class="pay-apply-item-content">
                    
                    <a-radio-group @change="idCardTypeChanged" v-model="hp.idCardType">
                        <a-radio :value="1">定期</a-radio>
                        <a-radio :value="2">长期</a-radio>
                    </a-radio-group>
                
                </div>
            
            </div>
            
            <div class="pay-apply-item">
                
                <div class="pay-apply-item-title">证件生效日期</div>
                
                <div class="pay-apply-item-content">
                    
                    <a-date-picker
                        v-model="params.id_card_info.id_card_valid_time_begin"
                        class="date-picker pay-apply-input"
                        format="YYYY-MM-DD"
                        placeholder="选择日期"
                    />
                
                </div>
            
            </div>
            
            <div class="pay-apply-item" v-if=" hp.idCardType === 1 ">
                
                <div class="pay-apply-item-title">证件失效日期</div>
                
                <div class="pay-apply-item-content">
                    
                    <a-date-picker
                        v-model="params.id_card_info.id_card_valid_time"
                        class="date-picker pay-apply-input"
                        format="YYYY-MM-DD"
                        placeholder="选择日期"
                    />
                
                </div>
            
            </div>
        
        </pay-box>
        
        <div class="pay-apply-btns">
            <button @click="changeStep(2)" class="btn btn-white">返回</button>
            <button @click="changeStep(4)" class="btn">下一步</button>
        </div>
    
    </div>
</template>

<script>
import PayBox from "./PayBox";
import AtInput from "../../../../components/AtInput";
import UploadImage from "../../../../components/UploadImage";
import api from "../../../../repo/api";
import ecApply from "@/store/ec-apply";

export default {
    name: "Step3",
    components: {UploadImage, AtInput, PayBox},
    data() {
        return {
            applyManager: ecApply,
            hp: {
                idCardType: 1
            },
            apply: ecApply.apply,
            params: {
                business_license_info: {
                    business_license_copy: '',
                    business_license_number: '', // 注册号/统一社会信用代码
                    merchant_name: '', // 商户名称
                    legal_person: '', // 个体户经营者/法人姓名
                    img_url: '',
                },
                id_card_info: {
                    id_card_copy: '', // 身份证人像面照片
                    id_card_national: '',//身份证国徽面照片
                    id_card_name: '',   //身份证姓名
                    id_card_number: '', //身份证号码
                    id_card_valid_time_begin: '', // 身份证有效期开始时间
                    id_card_valid_time: '', // 身份证有效期结束时间
                    img_a_url: '',
                    img_b_url: '',
                }
            }
        }
    },
    mounted() {
        
        if (this.apply.business_license_info) {
            this.params.business_license_info = this.apply.business_license_info
        }
        
        if (this.apply.id_card_info) {
            this.params.id_card_info = this.apply.id_card_info
        }
        
        if (this.applyManager.getApplyValue('id_card_info.id_card_valid_time') === '长期') {
            this.hp.idCardType = 2
        }
    },
    methods: {
        changeStep(step) {
            this.saveChange(step)
        },
        busLicUploadDone(res) {
            this.params.business_license_info.legal_person = res['legal_representative']
            this.params.business_license_info.business_license_number = res['reg_num']
            this.params.business_license_info.merchant_name = res['enterprise_name']
            this.params.business_license_info.business_license_copy = res['media_id']
            this.params.business_license_info.img_url = res['img_url']
        },
        idCardADone(res) {
            this.params.id_card_info.id_card_copy = res['media_id']
            this.params.id_card_info.img_a_url = res['img_url']
            this.params.id_card_info.id_card_name = res['name']
            this.params.id_card_info.id_card_number = res['id']
        },
        idCardBDone(res) {
            
            this.params.id_card_info.id_card_national = res['media_id']
            this.params.id_card_info.img_b_url = res['img_url']
            this.params.id_card_info.id_card_valid_time_begin = res['date_begin']
            this.params.id_card_info.id_card_valid_time = res['date_end']
            
            this.hp.idCardType = res['date_end'] === '长期' ? 2 : 1
        },
        idCardTypeChanged(val) {
            this.params.id_card_info.id_card_valid_time = val === 1 ? '' : '长期'
        },
        saveChange(step) {
            
            this.$loading.show()
            
            api.post('/ec-pay-apply/save-body-info', this.params, (data) => {
                
                this.$loading.hide()
                
                if (data.code !== 0) this.$message.data(data)
                
                if (data.code === 0) {
                    this.applyManager.gotoStep(step, data.data)
                }
            })
        }
    },
    computed: {
        uploadBusLicUrl() {
            return api.colUrl('/ec-pay-apply/upload-business-license')
        },
        uploadIdCardAUrl() {
            return api.colUrl('/ec-pay-apply/upload-id-card-a')
        },
        uploadIdCardBUrl() {
            return api.colUrl('/ec-pay-apply/upload-id-card-b')
        }
    }
}
</script>

<style lang="less" scoped>
.date-picker {
    
    /deep/ .ant-input {
        height: 40px;
        border-radius: 0;
    }
    
    /deep/ .ant-calendar-range-picker-separator {
        line-height: 30px;
    }
}


</style>